export const ADMINISTRATORS = "administrators";
export const FORGOT_PASSWORD = "forgot-password";
export const LOGIN = "login";
export const NEWS = "news";
export const PRESS_RELEASES = "press-releases";
export const RESET_PASSWORD = "action/reset-password";
export const SET_PASSWORD = "action/set-password";
